document.addEventListener("DOMContentLoaded", () => {
  const patchAxeptio = () => {
    const host = document.querySelector("#axeptio_overlay .needsclick");
    if (!host || !host.shadowRoot) return false;

    const shadow = host.shadowRoot;
    const overlay = shadow.querySelector(".ax-website-overlay");
    if (!overlay) return false;

    overlay.style.height = "auto";
    overlay.style.top = "auto";
    overlay.style.bottom = "0";
    overlay.style.pointerEvents = "auto";

    return true;
  };

  // Try once immediately
  if (patchAxeptio()) return;

  // Then poll a few times while Axeptio loads
  let tries = 0;
  const maxTries = 40;
  const interval = setInterval(() => {
    if (patchAxeptio() || ++tries >= maxTries) {
      clearInterval(interval);
    }
  }, 300);
});
